module.exports = __webpack_public_path__ + "bff8871ad5af5920d2ef35a80e7bc9c9.png";